import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromWidgetPages from './+state/widget-pages.reducer'
import { WidgetPagesEffects } from './+state/widget-pages.effects'
import { WidgetPagesFacade } from './+state/widget-pages.facade'
import { GbDashboardSetupDataAccessMenuItemsModule } from '@galabid/gb-dashboard/setup/data-access-menu-items'

@NgModule({
  imports: [
    CommonModule,
    GbDashboardSetupDataAccessMenuItemsModule,
    StoreModule.forFeature(fromWidgetPages.WIDGET_PAGES_FEATURE_KEY, fromWidgetPages.widgetPagesReducer),
    EffectsModule.forFeature([WidgetPagesEffects]),
  ],
  providers: [WidgetPagesFacade],
})
export class GbDashboardBrandingDataAccessModule {}
